import { getParameterByName } from 'utils/urlHelper';
import React from 'react';
import ErrorPage from 'modules/App/components/ErrorPage/ErrorPage';

const ErrorPageContainer = () => {
  const message = getParameterByName('message') || undefined;
  const title = getParameterByName('title') || undefined;
  const backPage = getParameterByName('backPage') || undefined;
  return <ErrorPage message={message} title={title} backPage={backPage} />;
};
export default ErrorPageContainer;
